import React from 'react';
import { XIcon } from 'lucide-react';
import { SectionHeading } from './SectionHeading';
import { costs } from '../data/copy';
export function ProblemSection() {
  return <section className="defer-paint w-full bg-coal py-12 sm:py-14" aria-labelledby="problem-heading" data-id="element-144" data-mp="2lqgwkp38r9v5">
      <div className="mx-auto max-w-5xl px-6" data-id="element-145" data-mp="2vqhfwb141pzc">
        <SectionHeading eyebrow="El problema real" title={<span id="problem-heading" data-id="element-147" data-mp="39hvzok2udv7g">¿Te suena familiar?</span>} data-id="element-146" data-mp="2vppjixzovo80" />

        <div className="mx-auto mt-9 max-w-3xl space-y-5 border-l-2 border-gold/50 pl-6 sm:pl-8" data-id="element-148" data-mp="39gb893btqsdt">
          <p className="font-display text-xl font-bold leading-snug text-ivory sm:text-2xl" data-id="element-149" data-mp="35frbw1z2rssq">
            Es lunes a las 18:00. Llegás a la pista con 20 atletas: velocistas,
            vallistas, fondistas, saltadores y lanzadores. Todos en el mismo
            espacio. Niveles distintos. Objetivos distintos. Y vos sin un plan
            claro para la sesión.
          </p>
          <p className="font-sans text-[0.95rem] leading-relaxed text-stone" data-id="element-150" data-mp="1k3zk1wzl4h1a">
            Pasaste todo el domingo buscando ejercicios en YouTube, pegando
            cosas de diferentes fuentes, intentando que tenga coherencia. Y a
            mitad de la sesión te das cuenta de que no hay progresión real entre
            ejercicios, que los avanzados se aburren, que los principiantes no
            entienden el gesto — y que gastaste 4 horas planificando algo que se
            siente improvisado.
          </p>
        </div>

        <div className="mt-12" data-id="element-151" data-mp="125pequzwbe5o">
          <h3 className="text-center font-display text-xl font-bold leading-snug text-ivory sm:text-2xl" data-id="element-152" data-mp="172fv7jfm4brm">
            El costo real de no tener el sistema correcto
          </h3>

          <ul className="mt-7 grid gap-x-8 gap-y-6 sm:grid-cols-2 lg:grid-cols-3" data-id="element-153" data-mp="1bzy6hgh3r32s">
            {costs.map(cost => <li key={cost.title} className="flex gap-3" data-id="element-154" data-mp="1g11i1qs4acy7">
                <span className="mt-0.5 flex h-5 w-5 shrink-0 items-center justify-center rounded-full border border-track/50 bg-track/15" aria-hidden="true" data-id="element-155" data-mp="3duqdm7rnapiu">
                  <XIcon className="h-3 w-3 text-track" strokeWidth={3} data-id="element-156" data-mp="ozqva3qbbhty" />
                </span>
                <span data-id="element-157" data-mp="k1foy2z87pgh">
                  <span className="block font-sans text-[0.9rem] font-semibold leading-snug text-ivory" data-id="element-158" data-mp="k27jrbl01j5p">
                    {cost.title}
                  </span>
                  <span className="mt-1.5 block font-sans text-[0.82rem] leading-relaxed text-stone" data-id="element-159" data-mp="tzda2hlsh64v">
                    {cost.detail}
                  </span>
                </span>
              </li>)}
          </ul>
        </div>
      </div>
    </section>;
}